// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refundPolicyContainer {
  padding: 20px;
  max-width: 100%;
  margin: 0;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: left;
}

.policyContent {
  background-color: #FFF5E9;
  border-radius: 10px;
  padding: 25px;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  max-height: 800px; /* 최대 높이 설정 */
  overflow-y: auto; /* 세로 스크롤 가능 */
}

.policyIntro {
  margin-bottom: 20px;
  font-size: 16px;
}

.policySection {
  margin-bottom: 25px;
  text-align: left;
}

.sectionNumber {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.policyList {
  padding-left: 20px;
  margin: 0;
  text-align: left;
}

.policyList li {
  margin-bottom: 10px;
  line-height: 1.5;
  text-align: left;
}

.policyList li:last-child {
  margin-bottom: 0;
}

/* 모바일 대응 */
@media (max-width: 768px) {
  .policyContent {
    padding: 15px;
  }
  
  .pageTitle {
    font-size: 20px;
  }
  
  .sectionNumber {
    font-size: 16px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/RefundPolicy.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".refundPolicyContainer {\n  padding: 20px;\n  max-width: 100%;\n  margin: 0;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.policyContent {\n  background-color: #FFF5E9;\n  border-radius: 10px;\n  padding: 25px;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: left;\n  max-height: 800px; /* 최대 높이 설정 */\n  overflow-y: auto; /* 세로 스크롤 가능 */\n}\n\n.policyIntro {\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\n.policySection {\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n.sectionNumber {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.policyList {\n  padding-left: 20px;\n  margin: 0;\n  text-align: left;\n}\n\n.policyList li {\n  margin-bottom: 10px;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.policyList li:last-child {\n  margin-bottom: 0;\n}\n\n/* 모바일 대응 */\n@media (max-width: 768px) {\n  .policyContent {\n    padding: 15px;\n  }\n  \n  .pageTitle {\n    font-size: 20px;\n  }\n  \n  .sectionNumber {\n    font-size: 16px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
